<template>
  <v-card
      class="h-100 d-flex justify-center align-center"
      :key="props.value.id"
      v-if="props.value.id === CREATE_REMOCON_NAME"
      @click="onRemocon"
  >
    <v-card-item>
      <v-icon>mdi-plus</v-icon>
    </v-card-item>
  </v-card>
  <v-card :key="props.value.id" v-else>
    <v-toolbar color="primary" v-ripple @click="onRemocon">
      <v-toolbar-title>{{ props.value.name }}</v-toolbar-title>
    </v-toolbar>
    <v-card>

    </v-card>
    <v-card-text>
      <div class="d-flex flex-column" style="margin: -8px;">
        <div class="d-flex flex-column flex-1-0" style="position: relative;">
          <span class="ma-2" style="position: absolute;left: 16px;background-color: #f3f3f3;">
            버튼
          </span>
          <div class="ma-2 mt-4 pa-2 pt-4 flex-1-0" style="border: 1px solid #e0e0e0;border-radius: 5px">
            <div class="d-flex flex-wrap" style="margin: -4px;">
              <draggable v-model="props.value.buttons" item-key="id" @update="onButtonUpdate">
                <template #item="{element, index}">
                  <v-chip
                      color="primary"
                      class="ma-1 flex-0-0"
                      @click.stop="onButton(element.id)">
                    <template v-if="element.id === CREATE_BUTTON_NAME">
                      <v-icon>mdi-plus</v-icon>
                    </template>
                    <template v-else>
                      {{ element.name }}
                    </template>
                  </v-chip>
                </template>
              </draggable>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column" style="margin: -8px;">
        <div class="d-flex flex-column flex-1-0" style="position: relative;">
          <span class="ma-2" style="position: absolute;left: 16px;background-color: #f3f3f3;">
            제어명령
          </span>
          <div class="ma-2 mt-4 pa-2 pt-4 flex-1-0" style="border: 1px solid #e0e0e0;border-radius: 5px">
            <div class="d-flex flex-wrap" style="margin: -4px;">
              <draggable v-model="props.value.commands" item-key="id" @update="onCommandUpdate">
                <template #item="{element, index}">
                  <v-chip
                      color="red-darken-4"
                      class="ma-1 flex-0-0"
                      @click.stop="onCommand(element.id)">
                    <template v-if="element.id === CREATE_COMMAND_NAME">
                      <v-icon>mdi-plus</v-icon>
                    </template>
                    <template v-else>
                      {{ element.name }}
                    </template>
                  </v-chip>
                </template>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>

import {CREATE_REMOCON_NAME, CREATE_COMMAND_NAME, CREATE_BUTTON_NAME} from "@/common/constants";
import draggable from 'vuedraggable';
import {ref, watch} from "vue";

const props = defineProps(['value']);
const emit = defineEmits(['remocon', 'command', 'onButtonRearrange', 'onCommandRearrange']);

const onRemocon = () => emit('onRemocon');
const onButton = buttonId => emit('onButton', buttonId);
const onCommand = commandId => emit('onCommand', commandId);
const onButtonUpdate = ({newIndex, oldIndex}) => emit('onButtonRearrange', ({newIndex, oldIndex}));
const onCommandUpdate = ({newIndex, oldIndex}) => emit('onCommandRearrange', ({newIndex, oldIndex}));

</script>

<style scoped>

</style>
